import { useMutation } from "urql";

import { UpdateCustomerRiskMonitoringRemarksDocument } from "../../../graphql/generated.ts";

export const useUpdateRiskMonitoringRemarks = () =>
  useMutation(UpdateCustomerRiskMonitoringRemarksDocument);
